import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Rnd } from 'react-rnd';

interface Props {
  /** このダイアログが閉じられる際に呼ばれる関数。 */
  onClose?: () => void | undefined;
  /** このダイアログの内容。 */
  children: React.ReactNode;

  /** このダイアログのヘッダーに表示する要素。 */
  headerContents?: React.ReactNode | undefined;
}

/**
 * 構造ツリーウィンドウ。
 */
function SectionPsNoteWindow({ onClose, children, headerContents }: Props) {
  const [position, setPosition] = useState({
    x:
      // eslint-disable-next-line no-nested-ternary
      Number(localStorage.getItem('sectionPsNoteWindowX') ?? 100) + window.scrollX < 0
        ? 100 + window.scrollX
        : Number(localStorage.getItem('sectionPsNoteWindowX') ?? 100) + window.scrollX > window.innerWidth
        ? 100 + window.scrollX
        : Number(localStorage.getItem('sectionPsNoteWindowX') ?? 100) + window.scrollX,
    y:
      // eslint-disable-next-line no-nested-ternary
      Number(localStorage.getItem('sectionPsNoteWindowY') ?? 100) + window.scrollY < 0
        ? 100 + window.scrollY
        : Number(localStorage.getItem('sectionPsNoteWindowY') ?? 100) + window.scrollY > window.innerHeight
        ? 100 + window.scrollY
        : Number(localStorage.getItem('sectionPsNoteWindowY') ?? 100) + window.scrollY,
  });
  const [size, setSize] = useState({
    width: Number(localStorage.getItem('sectionPsNoteWindowWidth') ?? 950),
    height: Number(localStorage.getItem('sectionPsNoteWindowHeight') ?? 500),
  });

  /**
   * ウィンドウの位置を調整する（初回のみ）。
   */
  useEffect(() => {
    const { scrollX, scrollY, innerWidth, innerHeight } = window;

    let { x, y } = position;

    if (x < scrollX) {
      x = scrollX + 100;
    }
    if (y < scrollY) {
      y = scrollY + 100;
    }
    if (x + size.width > scrollX + innerWidth) {
      x = scrollX + innerWidth - size.width - 100;
    }
    if (y + size.height > scrollY + innerHeight) {
      y = scrollY + innerHeight - size.height - 100;
    }

    if (position.x !== x || position.y !== y) {
      setPosition({
        x,
        y,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** × ボタン押下時に実行される関数。prop で指定されていなければ、モーダルを閉じる動作のみ行う。 */
  const onCloseFunction =
    typeof onClose === 'function'
      ? onClose
      : () => {
          // empty
        };

  return ReactDOM.createPortal(
    <Rnd
      default={{
        x: position.x,
        y: position.y,
        width: size.width,
        height: size.height,
      }}
      className="section-popup-window"
      style={{
        position: 'fixed',
        paddingTop: '10px',
        paddingBottom: '10px',
        paddingLeft: '10px',
        paddingRight: '10px',
      }}
      onDragStop={(e, data) => {
        localStorage.setItem('sectionPsNoteWindowX', String(data.x));
        localStorage.setItem('sectionPsNoteWindowY', String(data.y));

        setPosition({
          x: data.x,
          y: data.y,
        });
      }}
      onResizeStop={(e, direction, ref) => {
        localStorage.setItem('sectionPsNoteWindowWidth', String(ref.offsetWidth));
        localStorage.setItem('sectionPsNoteWindowHeight', String(ref.offsetHeight > 1000 ? 1000 : ref.offsetHeight));

        setSize({
          width: ref.offsetWidth,
          height: ref.offsetHeight > 1000 ? 1000 : ref.offsetHeight,
        });
      }}
      dragHandleClassName="section-popup-window-header"
    >
      {/* ヘッダー。 */}
      <div
        style={{
          cursor: 'move',
          display: 'flex',
          justifyContent: headerContents ? 'space-between' : 'flex-end',
          borderBottom: '1px solid lightgray',
          marginBottom: '10px',
        }}
        className="section-popup-window-header"
        onDoubleClick={() => {
          localStorage.removeItem('sectionPsNoteWindowX');
          localStorage.removeItem('sectionPsNoteWindowY');
          localStorage.removeItem('sectionPsNoteWindowWidth');
          localStorage.removeItem('sectionPsNoteWindowHeight');
        }}
      >
        {/* prop で渡されてきた、ヘッダーに表示する要素。 */}
        {headerContents}
        {/* 閉じるボタン。 */}
        <button
          type="button"
          onClick={onCloseFunction}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            width: '20px',
            height: '20px',
          }}
        >
          ×
        </button>
      </div>
      <div className="section-popup-container">
        <div className="section-popup-scroller">{children}</div>
      </div>
    </Rnd>,
    document.body
  );
}

SectionPsNoteWindow.defaultProps = {
  onClose: undefined,
  headerContents: undefined,
};

export default SectionPsNoteWindow;
